import { useId } from "react";
import { InputText } from "primereact/inputtext";
import { Calendar } from 'primereact/calendar';
import { Message } from 'primereact/message';

export function NewCalendarForm({values, onChangeServiceId, onChangeDateRange}) {
  formId = useId();
  return (
    <>
      <div className="field grid">
        <label for={formId + '_service_id'} className="col-fixed" style={{width: '40%'}}>Oznaczenie kalendarza</label>
        <div className="col w-auto">
          <InputText 
            id={formId + '_service_id'} 
            value={values.service_id} 
            style="w-100" 
            onChange={onChangeServiceId} 
            invalid={Boolean(values.validation_errors.service_id)}
          />
          {
            (values.validation_errors.service_id) 
            ?
              <Message severity="error" className='mt-1' text={values.validation_errors.service_id} />
            :
              <></>
          }
        </div>
      </div>
      <div className="field">
        <label for={formId + '_date_range'}  className="col-fixed" style={{width: '40%'}}>Okres ważności</label>
        <div className="col w-auto">
            <Calendar
                inputClassName="w-100" 
                value={ (values.start_date || values.end_date) ? [values.start_date, values.end_date] : null}
                id={formId + '_date_range'}
                onChange={onChangeDateRange} 
                invalid={Boolean(values.validation_errors.date_range)}
                selectionMode="range"
                readOnlyInput hideOnRangeSelection
            />
            {
                (values.validation_errors.date_range) 
                ?
                <Message severity="error" className='mt-1' text={values.validation_errors.date_range} />
                :
                <></>
            }  
        </div>

      </div>
    </>
  );
}




